import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { useCheckCode, useSendCard, useGetSettings } from "../../Services/Api";
import useSound from "use-sound";
//звуки
import err from './sounds/err.mp3';
import used from './sounds/usedCode.mp3';
import newCode from './sounds/newCode.mp3';
import saveSucsess from './sounds/saveSucsess.mp3';

const hasRussianLetters = (str) => {
  const regex = /[а-яА-ЯЁё]/;
  return regex.test(str);
}
const artDataFoormater = (artData) => {
  if (!Array.isArray(artData)) return [];
  return artData.map(({ prod_date, status_id, counts, salesPointName }) => {
    const date = prod_date ? new Date(prod_date).toLocaleDateString() : 'без даты';
    const statusStr = ['неизвестено', 'ожидает', 'внесено', 'забраковано'][+status_id] || '';
    const countStr = `${counts} шт`;
    return `${salesPointName ? salesPointName : "без привязки"}: ${statusStr} - ${countStr}`
  })
}

const Form = () => {
  //звуки
  const [playErr] = useSound(err);
  const [playUsed] = useSound(used);
  const [playNewCode] = useSound(newCode);
  const [playSaveSucsess] = useSound(saveSucsess);
  const [salesPoint, setSalesPoint] = useState(null)

  //для формы
  const [globalSalesPoint, setGlobalSalesPoint] = useState(null)
  const [lockalSalesPoint, setLockalSalesPoint] = useState(null)


  const settingParser = (settings) => {
    // console.log(settings)
    if (settings?.payload?.dictionary && Array.isArray(settings?.payload?.dictionary)) {
      settings.payload.dictionary.forEach((dict) => {
        if (dict?.dictionaryName === "salesPoint" && dict?.items && Array.isArray(dict?.items) && dict.items.length) {
          setSalesPoint(dict.items)
          let storedSalesPoint = localStorage.getItem('salesPoint')
          const availablePoinIds = dict.items.map(({ id }) => `${id}`)
          if (!availablePoinIds.includes(`${storedSalesPoint}`)) {
            storedSalesPoint = dict.items[0].id;
          }
          setGlobalSalesPoint(storedSalesPoint)
          setLockalSalesPoint(storedSalesPoint)
          localStorage.setItem("salesPoint", storedSalesPoint)
        }
      })
    }
  }
  const setAndSaveGlobalSalesPoint = (point) => {
    setGlobalSalesPoint(point)
    localStorage.setItem("salesPoint", point)
  }
  const getSettings = useGetSettings(settingParser, () => { })


  const navigate = useNavigate();
  const codeRef = useRef(null);
  const prodDateRef = useRef(null);
  const keyboardTimeout = useRef(null);

  const saveRef = useRef(() => { });
  const clearRef = useRef(() => { });

  const [ccData, ccErr, checkCode, ccReset] = useCheckCode();
  const [scData, scErr, sendCard, scReset] = useSendCard();

  const keyListener = useCallback((e) => {
    if (e.code === "F2") saveRef.current();
    if (e.code === "F4") clearRef.current();
  }, [])
  useEffect(() => {
    //проверяем есть ли у нас активный токен пользователя. Если его нет - отправляем пользователя на
    //страницу логина
    const storedToken = localStorage.getItem('token')
    getSettings()
    if (!storedToken) navigate('/login');
    window.addEventListener("keydown", keyListener)
    return () => {
      clearTimeout(keyboardTimeout.current)
      window.removeEventListener("keydown", keyListener)
    }
  }, [])

  //форма ввода общих параметров партии
  const [gProdDate, setGProdDate] = useState("");
  const [gStoragePeriod, setGStoragePeriod] = useState("");
  const [gExpDate, setGExpDate] = useState("");
  //форма ввода данных отдельного продукта
  const [code, setCode] = useState("");
  const [art, setArt] = useState("");
  const [name, setName] = useState("");
  const [gtin, setGtin] = useState("");
  const [code1c, setСode1c] = useState("");
  const [prodDate, setProdDate] = useState("");
  const [storagePeriod, setStoragePeriod] = useState("");
  const [expDate, setExpDate] = useState("");
  //информация о результатах действия
  const [resultMessage, setResultMessage] = useState("");
  const [status, setStatus] = useState("Отсканируйте код");
  const [statusId, setStatusId] = useState("");
  const [progress, setProgress] = useState("");
  const [prodDateErr, setProdDateErr] = useState(false);
  const [artStat, setArtStat] = useState([]);
  const [prodName, setProdName] = useState('');
  const [rusError, setRusError] = useState(false);


  //эффект вызывается при окончании запроса проверки кода
  useEffect(() => {
    if (!ccErr && !ccData) {
      // Нет ни данных ни ошибок очищаем инфоблоки
      setResultMessage("")
      setStatus("Отсканируйте код")
      setStatusId("")
      setProdDateErr(false)
    } else if (ccErr) {
      //нашлись ошибки
      if (hasRussianLetters(code)) {
        setRusError(true)
      }
      setResultMessage(ccErr?.message)
      setStatus(`Ошибка: ${ccErr?.name}`)
      setStatusId("0")
      //т.к. при отправке возникла ошибка проиграем ее звук, чтоб пользоователь знал, что 
      //что-то пошло не так
      playErr()
    } else if (ccData) {
      //прилетели данные

      // заполняем статус и инфу
      setResultMessage(ccData?.payload?.resultMessage)
      setStatus(ccData?.payload?.status)
      setStatusId(ccData?.payload?.statusId)

      //заполняем информационные поля формы
      setArt(ccData?.payload?.art || '')
      setName(ccData?.payload?.name || '')
      setGtin(ccData?.payload?.gtin || '')
      setСode1c(ccData?.payload?.code1s || '')
      //заполняем массив информации по статусам
      setArtStat(artDataFoormater(ccData?.payload?.stat))
      //заполняем информационное поле с названием продукта
      setProdName(ccData?.payload?.name || '')

      //проверяем в каком статусе отсканированный штрихкод
      if (ccData?.payload?.statusId === "1") {
        //статус - код годный, еще не использованый - даты в поля формы берем из данных партии
        setLockalSalesPoint(globalSalesPoint)
        setProdDate(gProdDate);
        setStoragePeriod(gStoragePeriod);
        setExpDate(gExpDate);
        setProgress(`Для этого артикула готово ${ccData?.payload?.performed || '?'}/${ccData?.payload?.stock || '?'}`);
      } else if (ccData?.payload?.statusId === "2") {
        //статус - код годный, ранее использован - заполняем даты данными из ответа
        setLockalSalesPoint(ccData?.payload?.salesPointId || '')
        setProdDate(ccData?.payload?.prodDate || '');
        setStoragePeriod(ccData?.payload?.storagePeriod || '');
        setExpDate(ccData?.payload?.expDate || '');
        setProgress(`Для этого артикула готово ${ccData?.payload?.performed || '?'}/${ccData?.payload?.stock || '?'}`);

      } else if (ccData?.payload?.statusId === "0" || ccData?.payload?.statusId === "3") {
        //статус - код негодный очищаем поле код
        setCode("");
      }
      //курлыкалка
      if (ccData?.payload?.statusId === "0") {
        //err
        if (hasRussianLetters(code)) {
          setRusError(true)
        }
        playErr()
      } else if (ccData?.payload?.statusId === "1") {
        //код новый
        playNewCode()
        //автосохранение
        saveRef.current();
      } else if (ccData?.payload?.statusId === "2") {
        //код уже использовался - режим исправления/информации
        playUsed()
      } else if (ccData?.payload?.statusId === "3") {
        //код отозван, проигрываем ошибку тоже
        playErr()
      }
    }
  }, [ccData, ccErr])

  //эффект вызывается при окончании сохранения данных формы
  useEffect(() => {
    if (scErr) {
      //нашлись ошибки
      // console.log("Ошипка",ccErr)
      setResultMessage(scErr?.message)
      setStatus(`Ошибка: ${scErr?.name}`)
      setStatusId("0")
      //при сохранении возникла ошибка проигрываем звук ошибки
      playErr();
    } else if (scData) {
      clear();
      setResultMessage(scData?.payload?.resultMessage)
      setStatus(scData?.payload?.status)
      setStatusId("")
      //заполняем массив информации по статусам
      setArtStat(artDataFoormater(scData?.payload?.stat))
      //заполняем информационное поле с названием продукта
      setProdName(scData?.payload?.name || '')
      if (scData?.result === "OK") {
        playSaveSucsess();
      } else {
        playErr();
      }
    }

  }, [scData, scErr])

  /**очистка формы общих параметров партии */
  const gClear = () => {
    setGProdDate("");
    setGStoragePeriod("");
    setGExpDate("");
  }

  /**очистка формы данных отдельного продукта */
  const clear = () => {
    setCode("");
    setArt("");
    setGtin("");
    setСode1c("");
    setName("");
    setProdDate("");
    setStoragePeriod("");
    setExpDate("");
    setLockalSalesPoint(globalSalesPoint)
    ccReset();
    codeRef.current.focus();
  }

  /**Отправка данных */
  const save = () => {
    //Проверяем перед отправкой, чтоб дата была заполненна
    sendCard({ km: code, prodDate, expDate, storagePeriod, salesPointId: lockalSalesPoint })
    // if (prodDate != '') {
    //   sendCard({ km: code, prodDate, expDate, storagePeriod, salesPointId: lockalSalesPoint })
    // } else {
    //   playErr();
    //   setProdDateErr(true);
    //   prodDateRef.current.focus()
    // }
  }
  /**оберка над setProdData, которая в качестве сайд-эффекта очищает ошибку с поля даты */
  const prodDateHandleChange = (e) => {
    setProdDate(e.target.value)
    setProdDateErr(false)
  }
  const codeHandleChange = (e) => {
    setRusError(false)
    clearTimeout(keyboardTimeout.current)
    //пустые строки мы не шлем в код
    if (!!e.target.value) {
      keyboardTimeout.current = setTimeout(() => {
        checkCode({ km: e.target.value, salesPointId: globalSalesPoint })
      }, 300);
      setCode(e.target.value)
    }
  }

  saveRef.current = save;
  clearRef.current = clear;
  // const handleKD = (e) => {
  //   e.preventDefault();
  // }
  return (
    <div className="mainForm">
      <div className="gForm cont">
        <h2>Общие параметры партии</h2>
        <h5>Они автоматически заполняют поля для каждого элемента партии</h5>
        {/* Дата изготовления <input type="date" value={gProdDate} onChange={e => setGProdDate(e.target.value)} />&nbsp; */}
        {/* Срок годности (месяцев) <input type="number" value={gStoragePeriod} onChange={e => setGStoragePeriod(e.target.value)} />&nbsp; */}
        {/* Годен до <input type="date" value={gExpDate} onChange={e => setGExpDate(e.target.value)} />&nbsp; */}
        {/* <input type="button" value="Очистить" onClick={gClear} /> */}
        {salesPoint ? (
          <>
            Точка продаж:
            <select
              disabled={salesPoint?.length === 1}
              value={globalSalesPoint} onChange={e => setAndSaveGlobalSalesPoint(e.target.value)}>
              {salesPoint.map(({ id, value }) => <option value={id}>{value}</option>)}
            </select>
          </>
        ) : null}
      </div>
      <div className="cont">
        <h2>Данные конкретного изделия</h2>
        Код маркировки<br />
        <input className={`status${statusId}`} ref={codeRef} type="text" value={code} onChange={codeHandleChange} />
        {rusError ? (<div className="error">Запрошенный код не найден в базе, при этом в нем присутствуют русские буквы. Проверьте не включена ли русская раскладка на клавиатуре</div>) : null}
      </div>
      <table>
        <tbody>

          <tr>
            <td>
              Артикул<br /><input type="text" value={art} disabled /> <br />
              Наименование<br /><input type="text" value={name} disabled /> <br />
              GTIN<br /><input type="text" value={gtin} disabled /> <br /><br />
              Код 1с<br /><input type="text" value={code1c} disabled /> <br /><br />
              {salesPoint ? (
                <>
                  Точка продаж: <br />
                  <select disabled={salesPoint?.length === 1} value={lockalSalesPoint} onChange={e => setLockalSalesPoint(e.target.value)}>
                    {salesPoint.map(({ id, value }) => <option value={id}>{value}</option>)}
                  </select>
                </>
              ) : null}
              {/* Дата изготовления<br />
              <input
                className={["prodDate", `status${prodDateErr ? '0' : ''}`].join(' ')}
                type="date"
                ref={prodDateRef}
                value={prodDate}
                onChange={prodDateHandleChange}
              /> <br />
              Срок годности (месяцев)<br /><input type="number" value={storagePeriod} onChange={e => setStoragePeriod(e.target.value)} /> <br />
              Годен до<br /><input type="date" value={expDate} onChange={e => setExpDate(e.target.value)} /> <br /> */}
            </td>
            <td>
              <h5 className={`status${statusId}`}>{status}</h5>
              <p>{resultMessage}</p>
              <p className="prodName">{prodName}</p>
              <div className="artStat">
                {artStat.map(stat => <p>{stat}</p>)}
              </div>
              {/* <p>{progress}</p> */}
            </td>
          </tr>
          <tr>
            <td>
              <div className="save" />
              <input type="button" value="Сохранить (F2)" onClick={save} />
            </td>
            <td>
              <div className="clear" />
              <input type="button" value="Очистить (F4)" onClick={clear} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default Form;